/*
 * Public API Surface of utils
 */

export * from './lib/validators/ec/identification-validator';
export * from './lib/validators/ec/identification-type';
export * from './lib/color.service';
export * from './lib/files.service';
export * from './lib/google-analytics.service';
export * from './lib/google-tag-manager.service';
export * from './lib/storage.service';
export * from './lib/utils.module';
